import React from "react";
import { Container, Input, Label } from "./styles";

export const TextArea = React.forwardRef(({ label, ...rest}, ref)  => {
  return (
    <Container>
      
      { label && <Label>{ label }</Label> }
      <Input ref={ref} { ...rest }/>
    </Container>
  )
})